/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { LargeFeedFilter } from "cms/components/components/feed-model/display/large";
import { getModelName } from "data/resources/model-items-config";

const FeedModelComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const {
        selected_type,
        selected_category,
        enable_bar: enable_bar,
    } = component || {};
    const hasType = !!selected_type;
    const selected = hasType ? getModelName(selected_type) : "None";

    return (
        <>
            <h2>Selected Model Type: {selected}</h2>
            <h3>Selected Category: {selected_category}</h3>
            {hasType &&
                <LargeFeedFilter
                    type={selected_type}
                    selectedCategory={selected_category}
                    enableBar={enable_bar}
                />
            }
        </>
    );
};

FeedModelComponentDisplay.displayName = "FeedModelComponentDisplay";
export { FeedModelComponentDisplay };
